import { Text } from '@medly-components/core';
import { EmptyGraphLayoutWrapper, EmptyGraphTextWrapper, EmptyGraphWrapper } from './ScatterPlot.styled';
import EmptyGraphNode from 'assets/images/gear/empty-graph-node.png';

export const EmptyGraph = ({ height, text = '' }: { height: number; text?: string }) => {
    return (
        <EmptyGraphWrapper data-testid="empty-graph" height={`${height}px`}>
            <EmptyGraphLayoutWrapper height={`${height}px`}>
                <EmptyGraphTextWrapper>
                    <img height={40} width={40} src={EmptyGraphNode} />
                    <Text textAlign="center" textVariant="h3" textWeight="Medium">
                        {text}
                    </Text>
                </EmptyGraphTextWrapper>
            </EmptyGraphLayoutWrapper>
        </EmptyGraphWrapper>
    );
};
